import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ManufacturerTableAction } from "stores/ManufacturerStore/ManufacturerAction";

const mapStateToProps = (state) => {
  return {
    SelectVehicleListdata:state.manufacturer.SelectVehicleListdata,
    SelectVehicleModelListdata:state.manufacturer.SelectVehicleModelListdata,
    vehicleVariantList:state.manufacturer.vehicleVariantList,
    isloadingvehicleVariant:state.manufacturer.vehicleVariant,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getSlectVehicleAction:ManufacturerTableAction.getSlectVehicle,
  getSlectVehicleModelAction:ManufacturerTableAction.getSlectVehicleModel,
  getVehicleVariantAction:ManufacturerTableAction.getVehicleVariantAction
}, dispatch);

const VehicleVariantStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default VehicleVariantStore;